import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import React = require('react');

import WebHttpClient from '~src/httpClient/WebHttpClient';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import {
  IIsDataMonitoringAdminUIEnabledParams,
  IsDataMonitoringAdminUIEnabledRequest,
} from '../../../serverApi/requests/IsDataMonitoringAdminUIEnabledRequest';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
export const DATA_CHANGE_RADAR_CHECKBOX = 'data-change-radar-setting-checkbox';

export function DataChangeRadarSection() {
  // Check if we should show this section only on the initial render
  const [showSection, setShowSection] = React.useState(false);

  React.useEffect(() => {
      WebHttpClient.sendRequest<
        IIsDataMonitoringAdminUIEnabledParams,
        boolean
      >(new IsDataMonitoringAdminUIEnabledRequest({})).then((result) => {
        if (result) {
          setShowSection(true);
        }
      });
    }, []);

  if (!showSection) {
    return null;
  }

  return (
    <SettingsSection
      title={Messages.dataChangeRadarSiteSettingTitle()}
      description={Messages.dataChangeRadarSiteSettingDescription()}
    >
      <FormikCheckbox
        name={'settings.dataChangeRadarEnabled'}
        label={Messages.dataChangeRadarSiteSettingToggleText()}
        testId={DATA_CHANGE_RADAR_CHECKBOX}
      />
      <div>
        <ul>
         <li>{Messages.dataChangeRadarSiteSettingPossibleLocation1()}</li>
         <li>{Messages.dataChangeRadarSiteSettingPossibleLocation2()}</li>
         <li>{Messages.dataChangeRadarSiteSettingPossibleLocation3()}</li>
        </ul>
      </div>
    </SettingsSection>
  );
}

/* for registering the component in settings registry */
export const DataChangeRadarSectionSpecs = componentRegistryEntry({
  name: 'DataChangeRadarSection',
  component: DataChangeRadarSection,
});
